import Beta from './Beta';

export default Beta;
